<template>
	<div class="page">
		<template v-if="isShow">
			<div class="rotation">
				<div class="dongtu dongtuBg"></div>
				<div class="dongtu-data">{{ cunt }}%</div>
				<div class="rotation-data1">流量监测</div>
			</div>
		</template>
		<template v-if="!isShow">
			<div class="diagonsis-contetn">
				<div class="result-h">
					<div class="jce">
						<div class="jce-num">有<span>{{ total }}</span>项异常！</div>
						<div class="result">检测结果</div>
					</div>
					<div class="el-tbn">
						<div class="el-btn" @click="weight">重新诊断</div>
					</div>
				</div>
				<div class="el-flex-content">
					<div class="el-flex-items" v-for="(item, index) in dataList" :key="index">
						<div class="itmetop">
							<div class="img1"><img :src="require(`../../assets/newUser/${item.icon}`)" alt=""></div>
							<div class="text">{{ item.name }}</div>
							<div class="img2">
								<img src="@/assets/newUser/23.png" alt="" v-if="item.state === 0">
								<img src="@/assets/newUser/25.png" alt="" v-if="item.state === 1">
							</div>
							<div class="text2">{{ item.remark }}</div>
							<div class="text3" @click="changeFalg(item, index)">
								<span>
									{{ !item.falg ? '展开' : "收起" }}
								</span>
								<van-icon :name="!item.falg ? 'arrow-down' : 'arrow-up'" />
							</div>
						</div>
						<div class="jianceShow" v-if="item.falg">
							<div class="text4">{{ item.remarkInfo }}</div>
							<div class="el-btn1" @click="pageChange(item)" v-if="item.state === 0">{{ item.btnName }}</div>
						</div>
					</div>
				</div>
				<div class="footer">
					<span class="t">无异常仍然无法使用，查看</span>
					<span class="link">解决方案</span>
				</div>
			</div>
		</template>
	</div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast, Dialog } from 'vant';
export default {
	data() {
		return {
			iccid: localStorage.getItem("iccid"),
			isShow: true,
			cunt: 0,
			total: 0,
			timer: null,
			simInfo: {},
			dataList: [],
		}
	},
	created() {
		this.init();
		wxRequest("sim/detail", { iccid: this.iccid }, "post").then((res) => {
			if (res.data.code === '200') {
				this.simInfo = res.data.data
			}
		})
	},
	methods: {
		init() {
			this.timer = setInterval(() => {
				if (this.cunt > 99) {
					this.isShow = false
					this.timer = null;
					clearInterval(this.timer);
				} else {
					this.cunt++
				}
			}, 100);
			this.dataList = []
			wxRequest("/sim/new/oneButton", { iccid: this.iccid }, "post").then((res) => {
				if (res.data.code === "200") {
					res.data.data.accountMap.name = '余额检测'
					res.data.data.accountMap.btnName = '充值余额'
					res.data.data.accountMap.icon = '20.png'
					res.data.data.accountMap.falg = false

					res.data.data.authStateMap.name = '实名状态'
					res.data.data.authStateMap.btnName = '去实名'
					res.data.data.authStateMap.icon = '18.png'
					res.data.data.authStateMap.falg = false

					res.data.data.dataMap.name = '流量检测'
					res.data.data.dataMap.btnName = '前往订购'
					res.data.data.dataMap.icon = '17.png'

					res.data.data.huoDongMap.name = '活动检测'
					res.data.data.huoDongMap.btnName = '活动详情'
					res.data.data.huoDongMap.icon = '21.png'

					res.data.data.pkgMap.name = '套餐检测'
					res.data.data.pkgMap.btnName = '前往订购'
					res.data.data.pkgMap.icon = '16.png'

					res.data.data.simStateMap.name = '卡状态检测'
					res.data.data.simStateMap.btnName = '前往订购'
					res.data.data.simStateMap.icon = '19.png'
					this.dataList = [res.data.data.accountMap, res.data.data.authStateMap, res.data.data.dataMap, res.data.data.huoDongMap, res.data.data.pkgMap, res.data.data.simStateMap]
					this.dataList = this.dataList.sort((a, b) => {
						return a.state - b.state
					})
					this.total = this.dataList.filter(v => v.state === 0).length
					clearInterval(this.timer);
					this.isShow = false
				} else {
					Toast.fail(res.data.message);
				}
			})
		},
		changeFalg(data, index) {
			this.$set(this.dataList[index], 'falg', !data.falg)
			this.$forceUpdate()
		},
		pageChange(data) {
			if (data.name === '套餐检测' || data.name === '流量检测' || data.name === '账期检测') {
				if (this.simInfo.endTimeDay >= 31 && this.simInfo.surplusFlowRate > 1024 * 15) {
					Dialog.confirm({
						title: '温馨提示',
						message: '您的套餐流量充足，暂无需重复购买套餐！'
					}).then(() => {
					})
						.catch(() => { })
				} else {
					this.$router.push({
						path: "/user/recharge",
						query: {
							iccid: this.iccid,
						},
					});
				}
			} else if (data.name === '实名状态') {
				this.realNameRegister();
			} else if (data.name === '余额检测') {
				this.$router.push({
					path: "/newUser/recharge",
				});
			} else if (data.name === '活动检测') {
				this.$router.push({
					path: "/newUser/coupon",
				});
			}
		},
		weight() {
			this.isShow = true
			this.init()
		},

		realNameRegister() {
			wxRequest("sim/detail", { iccid: this.iccid }, "post").then((res) => {
				if (res.data.code === '200') {
					this.simInfo = res.data.data
					var simpkg = {
						iccid: this.simInfo.iccid,
					};
					let iccid = this.simInfo.iccid;
					wxRequest("bindPhone/sim/pkg", simpkg, "post").then((res) => {
						if (res.data.code != 200) {
							Dialog.confirm({
								title: "购买套餐提醒",
								message: "请点击 确定 购买套餐后，再进行实名激活操作！",
							}).then((action) => {
								if (action == "confirm") {
									this.$router.replace("/user/recharge");
								}
							}).catch(() => { });
						} else {
							if (
								this.simInfo.supplierTypeCode == 1 ||
								this.simInfo.supplierTypeCode == 5
							) {
								Dialog.confirm({
									title: "实名提示",
									message:
										"请复制此ICCID：" +
										this.simInfo.iccid +
										"，点击确认 去完成实名",
								})
									.then(() => {
										window.location.href =
											"http://iotapp.iot.189.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp=1581922935504";
									})
									.catch(() => { });
							} else if (this.simInfo.supplierTypeCode == 3) {
								//移动
								wxRequest("/sim/get/cmcc/auth", { iccid: iccid }, "get").then((res) => {
									if (res.data.code == 200) {
										window.location.href = res.data.data;
									} else {
										Dialog.alert({
											title: "提示",
											message: res.data.message,
										});
									}
								});
							} else {
								Dialog.confirm({
									title: "实名提示",
									message:
										"已自动复制实名卡号！卡号为：" +
										iccid +
										"，点击确定去完成实名后 方可正常激活使用.如已实名 请忽略",
								})
									.then((action) => {
										Toast.fail("卡号复制成功");
										if (action == "confirm") {
											// var clipboard = new Clipboard(".tag-read");
											// clipboard.on("success", (e) => {
											//   console.log("复制成功");
											//   clipboard.destroy(); // 释放内存
											// });
											if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
												//ios系统
												window.getSelection().removeAllRanges(); //这段代码必须放在前面否则无效
												let inputDom = document.createElement("input");
												document.body.appendChild(inputDom);
												// inputDom.setAttribute("value", iccid);
												// let copyDom=document.getElementById("copyDom");//要复制文字的节点
												// copyDom.appendChild(inputDom);// 把标签添加给body
												// inputDom.style.opacity = 0;//设置input标签设置为透明(不可见)
												inputDom.value = iccid; // 修改文本框的内容
												inputDom.select();
												let range = document.createRange();
												// 选中需要复制的节点
												range.selectNode(inputDom);
												// 执行选中元素
												window.getSelection().addRange(range);
												inputDom.setSelectionRange(0, inputDom.value.length); //适配高版本ios
												// 执行 copy 操作
												document.execCommand("copy");
												// 移除选中的元素
												window.getSelection().removeAllRanges();
												document.body.removeChild(inputDom);
											} else {
												const save = function (e) {
													e.clipboardData.setData("text/plain", iccid);
													e.preventDefault(); // 阻止默认行为
												};
												document.addEventListener("copy", save);
												document.execCommand("copy");
											}
											window.location.href =
												"https://env-9gk22lag4fab0241-1309553396.tcloudbaseapp.com/jump-mp.html";
										}
									})
									.catch(() => { });
							}
						}
					});
				} else {
					Toast.fail(res.data.message);
				}
			})

		},
	}
}
</script>
<style lang="less" scoped>
div {
	display: flex;
	flex-grow: 0;
	flex-basis: auto;
	align-items: stretch;
	flex-direction: column;
}

.page {
	height: 100%;
	background: #f7f8fa;

	.rotation {
		height: 100%;
		position: relative;
		background: #2296f1;

		.dongtuBg {
			background: url('../../assets/newUser/14.png') no-repeat center;
			background-size: 100%;
			width: 240px;
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			margin: auto;
			position: absolute;
			height: 240px;
		}

		.dongtu-data,
		.rotation-data1 {
			top: 0;
			bottom: 0;
			left: 0;
			right: 0;
			margin: auto;
			width: 100px;
			position: absolute;
			height: 225px;
			line-height: 225px;
			margin: auto;
			text-align: center;
			font-size: 16px;
			font-weight: 800;
			color: #61e2fc
		}

		.rotation-data1 {
			top: 260px;
		}

		@-webkit-keyframes rotation-data {
			from {
				-webkit-transform: rotate(0deg)
			}

			to {
				-webkit-transform: rotate(1turn)
			}
		}

		.dongtu {
			-webkit-transform: rotate(1turn);
			animation: rotation-data 3s linear infinite;
			-moz-animation: rotation-data 3s linear infinite;
			-webkit-animation: rotation-data 3s linear infinite;
			-o-animation: rotation-data 3s linear infinite
		}
	}

	.diagonsis-contetn {
		align-items: center;

		.result-h {
			background: rgb(34, 150, 241);
			z-index: 9;
			width: 100%;

			.jce {
				background: url('../../assets/newUser/13.png') no-repeat center;
				width: 138px;
				height: 138px;
				background-size: 100%;
				align-self: center;
				align-items: center;
				margin-top: 20px;

				.jce-num {
					margin-top: 50px;
					flex-direction: row;
					font-size: 19px;
					font-weight: 700;
					color: #fff;
					margin-left: 14px;

					span {
						font-size: 19px;
						color: #ff0;
					}
				}

				.result {
					font-size: 13px;
					font-weight: 400;
					color: #61e2fc;
					margin-top: 20px;
				}
			}

			.el-tbn {
				height: 114px;
				background-size: 100%;
				display: flex;
				background: url('../../assets/newUser/15.png')no-repeat center;
				background-size: 100%;
				flex-direction: column-reverse;
				align-items: center;
				margin-bottom: -2px;

				.el-btn {
					width: 200px;
					height: 45px;
					line-height: 45px;
					text-align: center;
					font-weight: 700;
					color: #fff;
					font-size: 18px;
					background: #1c96f6;
					margin-bottom: 15px;
					border-radius: 200px;
				}
			}
		}

		.el-flex-content {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 95%;
			max-height: 350px;
			overflow: auto;

			.el-flex-items {
				background: #fff;
				padding: 12px 8px;
				margin-bottom: 10px;
				border-radius: 7px;
				width: 93%;

				.itmetop {
					flex-direction: row;
					align-items: center;

					.img1 {
						width: 24px;
						height: 24px;
					}

					.text {
						font-size: 16px;
						font-weight: 400;
						color: #06121e;
						margin-left: 2px;
						margin-right: 35px;
					}

					.img2 {
						width: 14px;
						height: 14px;
					}

					.text2 {
						font-size: 13px;
						font-weight: 400;
						color: #bdc4ce;
						margin-left: 4px;
						flex: 1;
					}

					.text3 {
						flex-direction: row;

						span {
							margin-right: 10px;
							font-size: 15px;
							font-weight: 400;
							color: #8c9198;
						}
					}
				}
			}

			.jianceShow {
				border-top: 1px solid #f7f8fa;
				flex-direction: row;
				align-items: center;
				margin-top: 10px;
				padding: 10px 0 0;

				.text4 {
					font-size: 14px;
					font-weight: 400;
					color: #bdc4ce;
					flex: 1;
				}

				.el-btn1 {
					padding: 6px 8px;
					background: #1c96f6;
					color: #fff;
					border-radius: 7px;
				}
			}

		}
	}

	.footer {
		padding: 15px;
		align-items: center;
		flex-direction: row;
		justify-content: center;
		background: rgb(247, 248, 250);

		.t {
			font-size: 13px;
			font-weight: 400;
			color: #06121e;
		}

		.link {
			font-size: 13px;
			font-weight: 400;
			color: #1c96f6;
			text-decoration: underline;
			margin-left: 5px;
		}
	}
}
</style>
